var _rect, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 12,
    fill: "#212121"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 24.209C26 25.0374 26.6716 25.709 27.5 25.709C28.3284 25.709 29 25.0374 29 24.209C29 23.3806 28.3284 22.709 27.5 22.709C26.6716 22.709 26 23.3806 26 24.209Z",
    stroke: "url(#paint0_linear_2501_2584)",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9 18.209C28.9656 17.8859 29 17.5515 29 17.209C29 14.4476 26.7614 12.209 24 12.209C21.2386 12.209 19 14.4476 19 17.209C19 17.5515 19.0344 17.8859 19.1 18.209",
    stroke: "url(#paint1_linear_2501_2584)",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 18.2022H26C28.8284 18.2022 30.2426 18.2022 31.1213 19.0813C32 19.9604 32 21.3753 32 24.2051V26.2061C32 29.0359 32 30.4508 31.1213 31.3299C30.2426 32.209 28.8284 32.209 26 32.209H20C16.2288 32.209 14.3432 32.209 13.1716 31.0369C12 29.8647 12 27.9782 12 24.2051V22.2042C12 18.4311 12 16.5446 13.1716 15.3724C14.1147 14.4289 15.5204 14.2449 18 14.209H20",
    stroke: "url(#paint2_linear_2501_2584)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2501_2584",
    x1: 26,
    y1: 24.209,
    x2: 29,
    y2: 24.209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BFFDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2501_2584",
    x1: 19,
    y1: 15.209,
    x2: 29,
    y2: 15.209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BFFDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2501_2584",
    x1: 12,
    y1: 23.209,
    x2: 32,
    y2: 23.209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BFFDC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.6e2c94691fbfd63b2f4194b0633351de.svg";
export { ForwardRef as ReactComponent };